import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CustomerDetailComponent } from '@routes/dialogs/customer-detail/customer-detail.component';
import { environment } from '@env/environment';
import { Constants } from '@shared/constants/constants';
import Role from '@shared/constants/role';
import { Company } from '@shared/enums/company';

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss']
})
export class CustomerSearchComponent extends DialogBase implements OnInit {
  title: any;
  customerType: any;
  bpNo: any;

  search: any;
  customerData: any[] = [];
  storeContactData: any[] = [];
  selectedData: any;

  newBsModalRef: BsModalRef = null;
  companies = Company;

  company;
  isDealerStaff = false;
  isDealerManager = false;
  isEditable = false;

  ngOnInit(): void {
    this.company = this.authService.getCurrentCompany();
    this.isDealerStaff = this.authService.getRolesByCompany(this.company).includes(Role.seaImDealerStaff);
    this.isDealerManager = this.authService.getRolesByCompany(this.company).includes(Role.seaImDealerSuperVisor);
    this.isEditable = [Company.Sea, Company.Seca].includes(this.company);
    const { username } = this.authService.getUser();
    // TODO Remove
    if (environment.isLocal && username === 'sol@dkrabbit.com') {
      this.search = username;
      this.showList();
    }

    if (this.customerType === 'Store') {
      this.showList();
    }

    // Fetch store contacts on init if customer type and bpNo is available
    if (this.customerType === 'Customer' && this.bpNo) {
      this.fetchStoreContacts();
    }
  }

  showList() {
    if (this.customerType === 'Customer' && !this.search) {
      return;
    }
    this.spinnerService.start();
    const api = this.customerType === 'Customer' ? this.apiService.bp.getBp(this.search) : this.apiService.user.getContact(this.bpNo);
    api
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.customerData = res?.customers || res;

        // Fetch store contacts if customer type and bpNo is available
        if (this.customerType === 'Customer' && this.bpNo) {
          this.fetchStoreContacts();
        }
      }, err => Utils.showError(err));
  }

  fetchStoreContacts() {
    this.apiService.user.getContact(this.bpNo)
      .subscribe(res => {
        this.storeContactData = res || [];
      }, err => {
        console.error('Error fetching store contacts:', err);
        this.storeContactData = [];
      });
  }

  selectRow(customer) {
    /*
    if (customer === this.selectedData) {
      return;
    }
    */
    console.log(`selectRow: ${customer}`);
    this.selectedData = customer;
    this.openCustomerDetail(this.customerType, false, true);
  }

  selectStoreContact(contact) {
    this.selectedData = contact;
    console.log('selectStoreContact:', contact);
    // Open customer detail dialog for store contact with flag
    this.openCustomerDetail('StoreContact', false, false);
  }

  openCustomerDetail(customerType, isNew?, isFromStoreContact?) {
    let initialState: any = {
      title: isNew ? 'Customer Create' : 'Customer Detail',
      customerType: customerType === 'StoreContact' ? 'Store' : customerType,
      isStoreContact: customerType === 'StoreContact',
      isFromStoreContact: isFromStoreContact,
    };
    if (!isNew) {
      const { bpNo, contactId, dealerBpNo, employeeNo, optOut } = this.selectedData;
      // Use the selected customer's bpNo for Customer type, dealer's bpNo for Store/StoreContact type
      const customerBpNo = customerType === Constants.customerType.CUSTOMER ? bpNo : this.bpNo;
      // For store contacts, ensure we pass the dealer's bpNo
      const finalDealerBpNo = customerType === 'StoreContact' ? this.bpNo : dealerBpNo;
      initialState = { ...initialState, bpNo: customerBpNo, dealerBpNo: finalDealerBpNo, contactId, employeeNo, optOut, email: this.selectedData.email };
    } else {
      if (this.customerType === Constants.customerType.STORE || customerType === 'StoreContact') {
        initialState = { ...initialState, bpNo: this.bpNo };
      }
    }
    this.newBsModalRef = this.modalService.show(CustomerDetailComponent, {
      initialState,
      class: 'modal-customer-create'
    });
    this.newBsModalRef.content.onClose.subscribe(res => {
      if (res) {
        this.onClose.next(res);
        this.bsModalRef.hide();
      } else {
        this.newBsModalRef = null;
      }
    });
  }
}
